import { Action } from '@/_core/fluxstore/types';
import { AccountState } from '../types';
import { useAccountStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';

import { GenerateApiToken as GenerateApiTokenCommand } from '@/api/account/commands';

const { registerMiddleware, registerReducer } = useAccountStore();

export class GenerateApiToken extends Action<AccountState> {
    public static ACTION_TYPE = 'GenerateApiToken';

    public _apiToken: string;
    public _apiTokenGeneratedAt: Date;

    public constructor() {
        super(GenerateApiToken.ACTION_TYPE);
    }
}

const middleware = async (state: AccountState, action: GenerateApiToken): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new GenerateApiTokenCommand(),
        onSuccess: (res) => {
            action._apiToken = res.ApiToken;
            action._apiTokenGeneratedAt = res.ApiTokenGeneratedAt;
        },
    });
};

const reducer = (state: AccountState, action: GenerateApiToken): void => {
    state.apiToken = action._apiToken;
    state.apiTokenGeneratedAt = action._apiTokenGeneratedAt;
};

//@ts-ignore
registerMiddleware(GenerateApiToken.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(GenerateApiToken.ACTION_TYPE, reducer);
